import './HeaderDetails.css'
function HeaderDetails({user, role}) {
  return (
    <div>
        <p className='User'>User ID : {user || 'Not logged in'}</p>
        <p className="Role">Role : {role || 'N/A'}</p>
    </div>
  )
}

export default HeaderDetails;
